import { useNodes } from '@xyflow/react';
import { memo } from 'react';

import { NodeType } from '@/components/flow';

import { ModelPanelSlideOut } from './ModelPanelSlideOut.tsx';

export type ModelPanelWrapperProps = {
  agentId: string;
};

const IModelPanelWrapper = ({ agentId }: ModelPanelWrapperProps) => {
  const nodes = useNodes() as NodeType[];
  const selectedNode = nodes.find((node) => node.selected);
  const modelId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:model'));

  if (!modelId || !selectedNode || selectedNode.data.resourceGroupType !== 'model') {
    return null;
  }

  return <ModelPanelSlideOut agentId={agentId} modelId={modelId} />;
};

export const ModelPanelSlideOutWrapper = memo(IModelPanelWrapper) as typeof IModelPanelWrapper;
